import {useState, useRef, useEffect} from 'react';
// ** Reactstrap Imports
import { Row, Col, Card, CardBody, Form, Label, Input, Button } from 'reactstrap';
import { useNavigate, useParams } from 'react-router-dom';

import axios from 'axios';
import { toast } from 'react-toastify';

import { MdOutlineAdd, MdRemove } from 'react-icons/md';
import { v4 as uuidv4 } from 'uuid';
import useAuth from '../../hooks/useAuth';

const EditCommunityFeature = () => {
  const { auth } = useAuth();

  const navigate = useNavigate();
  const {id} = useParams();
  const [communityFeature, setCommunityFeature] = useState({})

  const getData = async () => {
          try {
            const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/community-features/find/${id}`, {
                headers: {
                    'Authorization': 'Bearer ' + auth.accessToken
                }
            })
          
            setCommunityFeature(res.data);
          
        } catch (error) {
          error.response.data.message ? toast.error(error.response.data.message, {
            className: "error-toast",
            position: toast.POSITION.BOTTOM_RIGHT,
            autoClose: 3000
            }) :  toast.error(error.response.data.error, {
              className: "error-toast",
              position: toast.POSITION.BOTTOM_RIGHT,
              autoClose: 3000
          })
        }
      }
    

    useEffect(() => {
      getData();
     
    },[id])

   
    // ** States
   let initialState = communityFeature;


    const handleChange = (event) => {
        const { value, name } = event.target
        setCommunityFeature(prevValue => {
            return({
                ...prevValue,
                [name]: value
            })
        });
    }

    const handleUpdateClick = async (event) => {
        event.preventDefault();

        let featureName = communityFeature.featureName;
        let featureDesc = communityFeature.featureDesc;

        const formData = new FormData();
        formData.append('featureName', featureName);
        formData.append('featureDesc', featureDesc);
      


        try {
            const res = await axios.put(`${process.env.REACT_APP_API_BASE_URL}/community-features/update/${id}`, formData, {
                headers: {
                  'Content-Type': 'multipart/form-data',
                  'Authorization': 'Bearer ' + auth.accessToken
                }
            })
            toast.success(res.data.message, {
                className: "success-toast",
                autoClose: 3000,
                position: toast.POSITION.BOTTOM_RIGHT
            })
            navigate('/community/feature/view')


        } catch (error) {
          error.response.data.message ? toast.error(error.response.data.message, {
            className: "error-toast",
            position: toast.POSITION.BOTTOM_RIGHT,
            autoClose: 3000
            }) :  toast.error(error.response.data.error, {
              className: "error-toast",
              position: toast.POSITION.BOTTOM_RIGHT,
              autoClose: 3000
          })
            
        }
    }


    const handleReset = async (event) => {
      event.preventDefault();
      navigate('/community/feature/view')
    }
 
  return (
    <div className="container">
      <Row sm="12">
        <h5 className="sec-header">Edit Community Feature Information</h5>
      </Row> 
      <Row sm='12'>
        <Card>
            <CardBody>
            
          <Col sm='12' className='mb-2'>
          <Form>
            
             <div className='mb-1'>
              <Label className='form-label' for='featureName'>
                Feature Name <span className='text-danger'>*</span>
              </Label>
              <Input
                id='featureName'
                type='email'
                className='me-1'
                name='featureName'
                required={true}
                value={communityFeature.featureName}
                onChange={handleChange}
                
              />

            </div>

            <div className='mb-1'>
              <Label className='form-label' for='featureDesc'>
                Feature Description <span className='text-danger'>*</span>
              </Label>
              <Input
                id='featureDesc'
                type='textarea'
                className='me-1'
                name='featureDesc'
                required={true}
                value={communityFeature.featureDesc}
                onChange={handleChange}
                
              />
            </div>

           
            <Row className='pt-2'>
              <Col>
              <div className='mb-1'>
                <Button
                  block
                  color="success"
                  type='submit'
                  onClick={handleUpdateClick}
                >
                  Update
                </Button>
              </div>
          
              </Col>
              <Col>
                <div className='mb-1'>
                  <Button
                    block
                    color="warning"
                    onClick={handleReset}
                  >
                    Cancel & go to list
                  </Button>
                </div>         
              </Col>
            </Row>
          </Form>
            
          </Col>
          </CardBody>
        </Card>
          
      </Row>
    
    </div>
  );
};

export default EditCommunityFeature;
